import moment from "moment"

import angular from "angular"
import { trimStart } from "lodash"
import "./debug"
import "./uni-base-module"

// moment.locale("es")

console.log("uni-panel!!!")
console.log("angular.version", angular.version)
console.log("moment", moment())
console.log("moment", moment().format("dddd YYYY MMMM "))
console.log("lodash>" + trimStart("    -    foo ---"))
